import AddLinkModal from './modal/add_link';
import ConnectExternalForm from './modal/connect_external_form';
import { CreateFormObject } from '../../params/redux/form';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import { gray } from '../../theme/themePrimitives';
import { useState } from 'react';
import { Add, Facebook, KeyboardArrowDown, KeyboardArrowLeft, PostAdd, Search, Sort } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, InputAdornment, Menu, MenuItem, Typography } from '@mui/material';
import { setFilterForForms, settingCreateFormFlag, settingFormFieldObject, settingSelectedForm, settingSelectedFormType } from '../../redux/slices/form';
import { useDispatch, useSelector } from 'react-redux';

interface FormHeaderComponentProps {
    searched: string;
    setSearched: (value: string) => void;
    handleAdd?: () => void;
    sort: boolean;
    setSortValue: (value: boolean) => void;
    isTableView: boolean;
    setTableView: (value: boolean) => void;
}

const FormHeaderComponent = ({ searched, setSearched, sort, setSortValue }: FormHeaderComponentProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { forms, selectedFormType, assignedForms, filters } = useSelector((state: RootState) => state.form);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [addExternalForm, setAddExternalForm] = useState<boolean>(false);
    // const [anchorElForHeading, setAnchorElForHeading] = useState<null | HTMLElement>(null);

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    // const handleHeadingClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setAnchorElForHeading(event.currentTarget);
    // };

    const handleSelectedHeading = (value: 'form' | 'external' | 'facebook') => {
        dispatch(settingSelectedFormType(value));
        // setAnchorElForHeading(null);
    };

    const handleAddForm = () => {
        const data: CreateFormObject = {
            formTitle: 'Form 1',
            formDescription: '',
            isEditing: false,
            pipelineId: 0,
            stageId: 0,
            redirectUrl: '',
            redirectMessage: '',
            formTemplateId: 2,
            showTitle: 0,
            assignees: [],
            fields: [
                {
                    id: `field-submit-${Date.now()}`,
                    type: 'submit',
                    label: 'Submit',
                    btnAlign: 'left',
                    fontFamily: 'inherit',
                    labelColor: '#fff',
                    bgColor: '#000000',
                    btnSize: 'small'
                }
            ]
        };
        dispatch(settingFormFieldObject(data));
        dispatch(settingSelectedForm(null));
        dispatch(settingCreateFormFlag(true));
    };

    const formFilterHandler = (isDeleted: boolean, isInternal: boolean, isExternal: boolean) => {
        dispatch(setFilterForForms({
            isDeleted,
            isInternal,
            isExternal
        }));
    };

    return <>
        <Box display="flex" alignItems="center" gap={2} my={2}>
            {
                selectedFormType === 'facebook' && <Button variant="text" color="secondary" onClick={() => handleSelectedHeading('form')}><KeyboardArrowLeft />Back</Button>
            }
            <Typography variant="h3" color="textSecondary" sx={{
                fontSize: '1.5rem',
                fontWeight: 'bold'
            }}>
                {selectedFormType === 'form' ? 'Forms' : selectedFormType === 'external' ? 'External Links' : 'Facebook Forms'}
            </Typography>
        </Box>
        {/* <Menu
            anchorEl={anchorElForHeading}
            open={Boolean(anchorElForHeading)}
            onClose={() => setAnchorElForHeading(null)}
            MenuListProps={{
                'aria-labelledby': 'Heading-selection-button'
            }}
        >
            {selectedFormType !== 'form' && <MenuItem onClick={() => handleSelectedHeading('form')}>
                Forms
            </MenuItem>}
            {selectedFormType !== 'external' && <MenuItem onClick={() => handleSelectedHeading('external')}>
                External Links
            </MenuItem>}
            {selectedFormType !== 'facebook' && <MenuItem onClick={() => handleSelectedHeading('facebook')}>
                Facebook Forms
            </MenuItem>}
        </Menu> */}
        <Box display="flex" justifyContent="space-between" alignItems="center" my={1}>
            {selectedFormType === 'form' && (forms.length > 0 || assignedForms.length > 0) && <Box display="flex" alignItems="center" gap={1}>
                <Box>
                    <CustomInput
                        placeholder="Search..."
                        value={searched}
                        slotProps={{
                            input: {
                                startAdornment: <InputAdornment position="start">
                                    <Search />
                                </InputAdornment>
                            }
                        }}
                        onChange={(e) => setSearched(e.target.value)}
                    />
                </Box>
                <Button variant="outlined" startIcon={<Sort />} color={sort ? 'secondary' : 'primary'} onClick={() => setSortValue(!sort)}>Sort</Button>
                {/* <Button variant="outlined" startIcon={isTableView ? <CardGiftcard /> : <TableChart />} color="secondary"
                onClick={() => setTableView(!isTableView)}>{isTableView ? 'Card View' : 'Table View'}</Button> */}
            </Box>}
            {selectedFormType === 'form' && currentUser?.role !== 'client' && <Box display="flex" alignItems="center" gap={2}>
                <Box>
                    <CustomDropdown
                        value={filters.isExternal ? 'facebook' : filters.isInternal ? 'internal' : filters.isDeleted ? 'deleted' : 'choose'}
                        options={[
                            { label: 'Internal Forms', value: 'internal' },
                            { label: 'Facebook Forms', value: 'facebook' },
                            { label: 'Deleted Forms', value: 'deleted' }
                        ]}
                        placeholder="All Forms"
                        enabledDefaultSelection={true}
                        onChange={(e) => (e.target.value === 'choose' ? formFilterHandler(false, false, false) : formFilterHandler(e.target.value === 'deleted', e.target.value === 'internal', e.target.value === 'facebook'))}
                    />
                </Box>
                <Button sx={{ display: 'none' }} variant={filters.isDeleted ? 'outlined' : 'contained'} onClick={() => formFilterHandler(!filters.isDeleted, false, false)} color="error">View Deleted Forms</Button>
                <Button variant="contained" onClick={handleButtonClick} endIcon={<KeyboardArrowDown />}>Add Form</Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    MenuListProps={{
                        'aria-labelledby': 'add-form-button'
                    }}
                >
                    <MenuItem onClick={() => {
                        setAddExternalForm(true);
                        setAnchorEl(null);
                    }}>
                        <Box display="flex" alignItems="center" gap={1} color={gray[500]}><Add /><Typography variant="body1">Add External Form</Typography></Box>
                    </MenuItem>
                    <MenuItem onClick={handleAddForm}>
                        <Box display="flex" alignItems="center" gap={1} color={gray[500]}><PostAdd /><Typography variant="body1">Create New Form</Typography></Box>
                    </MenuItem>
                    <MenuItem onClick={() => handleSelectedHeading('facebook')}>
                        <Box display="flex" alignItems="center" gap={1} color={gray[500]}><Facebook /><Typography variant="body1">Add Facebook Form</Typography></Box>
                    </MenuItem>
                </Menu>
            </Box>}
            {/* {currentUser?.role === 'client' && <Typography color={brand[300]} variant="subtitle2">You have {assignedForms.length} forms asssigned to you</Typography>} */}
        </Box>
        {
            selectedFormType === 'external' && <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle1" color="textDisabled">Add the domains of the websites that you want to collect form submissions from in Gonzy.</Typography>
                <Button variant="contained" onClick={() => setShowModal(true)} endIcon={<Add />}>Add Links</Button>
            </Box>
        }
        {showModal && <AddLinkModal open={showModal} onClose={() => setShowModal(false)} />}
        {addExternalForm && <ConnectExternalForm open={addExternalForm} onClose={() => setAddExternalForm(false)} />}
    </>;
};

export default FormHeaderComponent;